export default {
  back: 'Terug naar menu',
  menu: 'Menu',
};
